import classNames from 'classnames';
import React, { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { appPostStructuredMessage } from '@common/utils/appUtils';
const Filters = (props) => {
    var _a;
    const { t } = useTranslation();
    // const [openDateFilter, setOpenDateFilter] = useState<boolean>(false);
    // const clearFilter = () => {
    //   props.setYear('');
    //   props.setMonth('');
    //   setOpenDateFilter(false);
    // };
    useEffect(() => {
        window.addEventListener('load', () => {
            const activeItem = document.querySelector('#monclernow-filter_tablist .filter-item--active');
            activeItem === null || activeItem === void 0 ? void 0 : activeItem.focus();
        });
    }, []);
    const categoryListing = useMemo(() => {
        var _a, _b;
        let categories = (_b = (_a = props.filters) === null || _a === void 0 ? void 0 : _a.find((r) => r.id === 'page.monclernowarticle.category')) === null || _b === void 0 ? void 0 : _b.values;
        const indexOfMonSelect = categories === null || categories === void 0 ? void 0 : categories.findIndex((el) => el.value == 'monclerselect');
        if (indexOfMonSelect >= 0) {
            const select = categories.splice(indexOfMonSelect, 1)[0];
            categories.unshift(select);
        }
        return categories;
    }, [props.filters]);
    // const yearListing = props.filters?.find((r) => r.id === 'page.monclernowarticle.year')?.values?.sort((a, b) => (parseFloat(a.value) < parseFloat(b.value) ? 1 : -1));
    // const monthListing = props.filters?.find((r) => r.id === 'page.monclernowarticle.month')?.values.sort((a, b) => (parseFloat(a.value) > parseFloat(b.value) ? 1 : -1));
    // const selectedYear = props.year ? yearListing.find(({ value }) => value === props.year)?.displayValue : '';
    // const selectedMonth = props.month ? (props.month === t('monclernow.allyear') ? props.month : monthListing.find(({ value }) => value === props.month)?.displayValue) : '';
    const filterRef = useRef([]);
    return (React.createElement("div", { className: "monclernow-filter__row" }, ((_a = props.filters) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "monclernow-filter_tablist", className: "monclernow-filter__first-level", role: "tablist" },
            React.createElement("button", { role: "tab", "aria-selected": !props.categoryActive || props.categoryActive === '' ? 'true' : 'false', "aria-controls": "monclernow-tab", onClick: (e) => {
                    // e.preventDefault();
                    props.setCategory('');
                    if (window.appmode) {
                        appPostStructuredMessage('firebase_analytics', {
                            event: 'moncler_now_interactions',
                            params: {
                                Action: 'moncler_now-filer_menu-' + t('monclernow.allcategoryanalytics'),
                                pageDetail: 'monclernow',
                            },
                        });
                    }
                }, ref: (el) => (filterRef.current[categoryListing.length] = el), tabIndex: !props.categoryActive || props.categoryActive === '' ? 0 : -1, 
                // href={updateURLParameter(location.href, 'category', '')}
                className: classNames('first-level__filter-item', { 'filter-item--active': !props.categoryActive || props.categoryActive === '' }), onKeyDown: (e) => {
                    var _a, _b;
                    // a11y: roving tabindex
                    // console.log(categoryListing.length);
                    let newTabIndex, newTabCategory;
                    if (e.key === 'ArrowLeft') {
                        newTabIndex = categoryListing.length - 1;
                        newTabCategory = categoryListing[newTabIndex].value;
                        // console.log(newTabIndex, newTabCategory);
                        props.setCategory(newTabCategory);
                        (_a = filterRef.current[newTabIndex]) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                    else if (e.key === 'ArrowRight') {
                        newTabIndex = 0;
                        newTabCategory = categoryListing[newTabIndex].value;
                        // console.log(newTabIndex, newTabCategory);
                        props.setCategory(newTabCategory);
                        (_b = filterRef.current[newTabIndex]) === null || _b === void 0 ? void 0 : _b.focus();
                    }
                } }, t('monclernow.allcategory')),
            categoryListing &&
                categoryListing.map((filter, i) => (React.createElement("button", { role: "tab", "aria-selected": props.categoryActive === filter.value ? 'true' : 'false', tabIndex: props.categoryActive === filter.value ? 0 : -1, "aria-controls": "monclernow-tab", key: i, ref: (el) => (filterRef.current[i] = el), 
                    // href={updateURLParameter(location.href, 'category', filter.value)}
                    className: classNames('first-level__filter-item', { 'filter-item--active': props.categoryActive === filter.value }), onClick: (e) => {
                        // e.preventDefault();
                        props.setCategory(filter.value);
                        if (window.appmode) {
                            appPostStructuredMessage('firebase_analytics', {
                                event: 'moncler_now_interactions',
                                params: {
                                    Action: 'moncler_now-filer_menu-' + filter.value,
                                    pageDetail: 'monclernow',
                                },
                            });
                        }
                    }, onKeyDown: (e) => {
                        var _a, _b;
                        // a11y: roving tabindex
                        let Index = i;
                        let newTabIndex, newTabCategory;
                        if (e.key === 'ArrowLeft') {
                            if (Index === 0) {
                                newTabIndex = categoryListing.length;
                                newTabCategory = '';
                            }
                            else {
                                newTabIndex = Index - 1;
                                newTabCategory = categoryListing[newTabIndex].value;
                            }
                            // console.log(newTabIndex, newTabCategory);
                            props.setCategory(newTabCategory);
                            (_a = filterRef.current[newTabIndex]) === null || _a === void 0 ? void 0 : _a.focus();
                        }
                        else if (e.key === 'ArrowRight') {
                            if (Index === categoryListing.length - 1) {
                                newTabIndex = categoryListing.length;
                                newTabCategory = '';
                            }
                            else {
                                newTabIndex = Index + 1;
                                newTabCategory = categoryListing[newTabIndex].value;
                            }
                            // console.log(newTabIndex, newTabCategory);
                            props.setCategory(newTabCategory);
                            (_b = filterRef.current[newTabIndex]) === null || _b === void 0 ? void 0 : _b.focus();
                        }
                    } }, t(`monclernow.category.${filter.displayValue}`)))))))));
};
export default Filters;
